import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import packageJson from '../package.json'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { appStore } from './redux/store'
import backendEndpoint from './api/etrBackend'
import ErrorBoundary from './component/ErrorBoundary'

async function logErrorToFile(errorMessage: any, source: any, lineno: any) {
  // send the request with the error message and other details as the payload
  const data = {
    error: errorMessage,
    source: source,
    lineno: lineno
  }
  //console.log(data)
  await backendEndpoint.post(`health/log`, data)
}

//window.onerror = logErrorToFile

if (window._env_.NODE_ENV === 'production') {
  /* eslint-disable */
  console.log = function () {}
}
console.log(`window._env_.NODE_ENV = ${window._env_.NODE_ENV}`)
console.log(`process.env.NODE_ENV = ${process.env.NODE_ENV}`)

ReactDOM.render(
  <React.StrictMode>
    <Provider store={appStore}>
      {/* <ErrorBoundary>
        <App />
      </ErrorBoundary> */}
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
